import React, {useState, useEffect} from 'react';
import axios from 'axios';

import URL from '../../../config/config-server-api';
import { Switch } from 'react-router-dom';


const PaymentControUse =({idnegocio})=>{

    const [paymentControlData, setPaymentControlDate] =useState({})

    useEffect(()=>{
        try {
            if(idnegocio!='' && idnegocio.length===24){
                var url = URL.UrlshowPaymetnCotrol+idnegocio;
                axios.get(url)
                .then(data=>{
                    console.log(data);
                    if(data.status===200){
                        setPaymentControlDate(
                            data.data.result
                        )
                    }
                })
                .catch(err=>{
                    console.log({err})
                })

            }
        } catch (error) {
            console.log('error in payment control')
        }
      
    },[])


    if(paymentControlData.state==='active'){
       return( <div className="bg-green-400 text-white font-bold flex flex-rows-1 p-2 rounded-lg">
                    <h2 className="font-extrabold">
                        Pago del servicio hasta {
                            paymentControlData.paymentPlan
                        }
                        </h2> 
                        <div className="text-bold mx-0 sm:mx-2 ">
                        😎
                    </div>
            </div>
       )
    }else
    return (
        <div className="bg-red-500 text-white font-bold flex flex-rows-1 p-2 rounded-lg">
        <h2 className="font-extrabold">
            Pago del servicio hasta {
                paymentControlData.paymentPlan
            }
            </h2> 
            <div className="text-bold mx-0 sm:mx-2 ">
            😴
        </div>
</div> 
    
    );
}

export default PaymentControUse;